export default __webpack_public_path__ + "static/media/轮播首图8.4e0d085e.jpg";